import { render, staticRenderFns } from "./DnsList.vue?vue&type=template&id=95724488"
import script from "./DnsList.vue?vue&type=script&lang=js"
export * from "./DnsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports